import { Injectable } from '@angular/core';
import { Models } from '@ibexfusion/models';

import { RestProvider, RestService } from '../rest/rest.service';
import { RestfulService } from '../rest/restful';

@Injectable()
export class FrontendErrorService extends RestfulService<Models.FrontendError> {

  constructor(public restService: RestService) {
    super(Models.FrontendError);
    super.init();
  }

  public createProvider(): RestProvider {
    return this.restService.createProvider('frontend-errors');
  }

}
